import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { OktaAuthModule } from '@okta/okta-angular';
import {
  AuthTokenInterceptor,
  ClientAppIdInterceptor,
  DEFAULT_HTTP_TIMEOUT,
} from './interceptors';
import { AUTH_MODULE_CONFIG } from './services';
import { AuthConfig } from './types/auth-config';

@NgModule({
  imports: [OktaAuthModule],
})
export class FeatureAuthModule {
  static forRoot(config: AuthConfig): ModuleWithProviders<FeatureAuthModule> {
    return {
      ngModule: FeatureAuthModule,
      // It is important that http interceptors are never dependant (even indirectly) of the configuration
      providers: [
        [{ provide: AUTH_MODULE_CONFIG, useValue: config }],
        [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true,
          },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: ClientAppIdInterceptor,
            multi: true,
          },
        ],
        [{ provide: DEFAULT_HTTP_TIMEOUT, useValue: 15000 }],
      ],
    };
  }
}
